import {Component, OnInit} from '@angular/core';
import {ApiRoutes} from "../../services/apiroutes";
import {FormControl} from "@angular/forms";
import {map, Observable, startWith} from "rxjs";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import {Router} from "@angular/router";
import {ChatService} from "../../services/chat.service";
import {option} from "../one-way/request-processing/request-processing.component";

@Component({
    selector: 'logzy-ops-data-change',
    templateUrl: './ops-data-change.component.html',
    styleUrls: ['./ops-data-change.component.scss']
})
export class OpsDataChangeComponent implements OnInit {

    request;
    request_url = `${ApiRoutes.LeadRequest}request_details/`

    searchCtrl = new FormControl('');
    filteredOptions: Observable<option[]>;
    Tutorial: boolean = false;
    noOverflow: boolean = false;
    play: boolean = false;
    options: option[] = [
        {
            icon: 'grade',
            name: 'option1',
        },
        {
            icon: 'hotel_class',
            name: 'option2',
        },
        {
            icon: 'schedule',
            name: 'option3',
        },
        {
            icon: 'lock',
            name: 'option4',
        },
        {
            icon: 'fingerprint',
            name: 'option5',
        },
    ];

    showTutorial() {
        this.Tutorial = !this.Tutorial;
        if (this.noOverflow == false) {
            this.noOverflow = this.Tutorial;
            this.play = true;
        } else {
            setTimeout(() => {
                this.noOverflow = this.Tutorial;
                this.play = false;
            }, 1000);
        }
    }

    navToProd(event: MatAutocompleteSelectedEvent) {
        const prod = event.option.value;
        // if (prod) {
        //   this.router.navigate(['master-search/container-search']); // change the url according to prod
        // }

    }

    constructor(private router: Router, private chatService: ChatService) {
        this.filteredOptions = this.searchCtrl.valueChanges.pipe(
            startWith(''),
            map(option => (option ? this._filterOptions(option) : this.options.slice())),
        );
    }

    private _filterOptions(value: string): option[] {
        const filterValue = value.toLowerCase();

        return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
    }

    ngOnInit(): void {
    }

    onRequestSelection(event) {
        if (event != null) {
            this.chatService.noAccessToChat = false;
            this.router.navigateByUrl(`/ops-date-change/request-details?id=${event.id}&type=${event.transaction_type}&rtype=${event.request_type.dev_name}`);
        }
    }

    addNewRequest() {
            this.router.navigateByUrl(`/ops-date-change/view`)
    }
}
